import { useState } from 'react'

import { ControlledInputSm } from '@apps-common/components/elements/form'
import { VertSpacerMd } from '@apps-common/components/layout'
import { CidEventCard } from '@apps-common/components/modals/cid-events/CidEventCard'
import {
  ModalBodyInfiniteScrollable,
  ModalCloseButton,
  ModalContainer,
  ModalHeader,
  ModalHeaderContainer
} from '@apps-common/components/modals/modal'
import { MESSAGE_GENERIC_ERROR } from '@apps-common/config/app-messages'
import { CID_EVENT_CODES } from '@apps-common/config/cid-event-codes'
import { ModalDismiss } from '@apps-common/config/modal'
import { toastError } from '@apps-common/lib/toast'
import { ICidEventModel } from '@apps-common/types/cid-event-code'

export const CidEventSelectModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: any
}) => {
  const [codeSearch, setCodeSearch] = useState<string>('')
  const [descSearch, setDescSearch] = useState<string>('')

  const onSelected = async (event: ICidEventModel) => {
    try {
      onDismiss(JSON.stringify(event), 'confirm')
    } catch (e: any) {
      toastError(MESSAGE_GENERIC_ERROR)
    }
  }

  return (
    <ModalContainer alwaysMobile innerClasses='sm:!min-h-[85lvh] !p-0'>
      <ModalHeaderContainer classes='!pb-0'>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle='Selection' title='Alarm Events' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
        <VertSpacerMd />
        <div className='flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-6 w-full'>
          <ControlledInputSm
            id='code-search'
            containerClassName='!mb-0 w-full'
            className=''
            type='text'
            label='Search code'
            placeholder='Enter code to search'
            hideErrors
            value={codeSearch}
            onChange={(e: any) => setCodeSearch(e?.target?.value || '')}
          />
          <ControlledInputSm
            id='desc-search'
            containerClassName='grow !mb-0 w-full'
            className=''
            type='text'
            label='Search description'
            placeholder='Enter description to search'
            hideErrors
            value={descSearch}
            onChange={(e: any) => setDescSearch(e?.target?.value || '')}
          />
        </div>
      </ModalHeaderContainer>
      <ModalBodyInfiniteScrollable classes='!pt-[165px] sm:!pt-[150px]'>
        <div className='flex flex-col gap-4'>
          {CID_EVENT_CODES.filter(
            (e) =>
              e.code.includes(codeSearch.length > 0 ? codeSearch : e.code) &&
              e.description.includes(descSearch.length > 0 ? descSearch : e.description)
          ).map((e, i) => (
            <CidEventCard key={`cid-event-code-${e.code}-${i}`} event={e} callback={() => onSelected(e)} />
          ))}
        </div>
      </ModalBodyInfiniteScrollable>
    </ModalContainer>
  )
}
